import React from "react";
import PropTypes from "prop-types";

const RelatedMediaCard = ({ url, title, image, placeholder, types, categories }) => {

	const renderedType = JSON.parse(types).map((type) => <span className="card__types-categories__type" key={type}>{type}</span> );
	const renderedCategory = JSON.parse(categories).map((category) => <span className="card__types-categories__category" key={category}>{category}</span> );

	return (
		<div className="related-media__card animate-hover">
			<a href={url}>
				<div className="card__wrapper">
					<div className="card__image">
						<div className="aspect-ratio-box">
							<img src={image ? image : placeholder} alt={title} />
						</div>
					</div>
					<div className="card__content">
						<div>
							<div className="card__types-categories">
								{renderedType}
								{renderedCategory}
							</div>
							<h3 className="h4 card__content__title hover-title" dangerouslySetInnerHTML={{__html: title }}/>
						</div>
					</div>
				</div>
			</a>
		</div>
	);
};

export default RelatedMediaCard;

RelatedMediaCard.propTypes = {
	title: PropTypes.string,
	types: PropTypes.string,
	url: PropTypes.string,
	image: PropTypes.string,
	excerpt: PropTypes.string,
	tagline: PropTypes.string,
};
